var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blank"},[_c('div',{staticClass:"icon"},[_c('Icon',{attrs:{"name":"record"}})],1),_c('span',[_vm._v("暂时还没有记录. 快去记一笔吧~")])])}
var staticRenderFns = []

export { render, staticRenderFns }